var map = {
	"./2857.png": "dd29",
	"./32.png": "f6f6",
	"./accion-popular.png": "cbe1",
	"./alianza-para-el-progreso.png": "a685",
	"./alianza-popular.png": "ad0b",
	"./alianza-por-el-futuro.png": "290b",
	"./alianza-por-el-gran-cambio.png": "6085",
	"./aun-no-decide-por-quien-votara.png": "7a75",
	"./avanza-pais---partido-de-integracion-social.png": "fbf3",
	"./avanza-pais.png": "b538",
	"./blanco-viciado.png": "7e2f",
	"./democracia-directa.png": "6bf1",
	"./frente-amplio.png": "8b9c",
	"./frente-de-centro.png": "bae6",
	"./frente-esperanza.png": "b511",
	"./frepap.png": "c985",
	"./fuerza-2011.png": "985c",
	"./fuerza-popular.png": "bb06",
	"./gana-peru.png": "a460",
	"./juntos-por-el-peru.png": "6be3",
	"./ninguno-blanco-viciado.png": "f27f",
	"./ninguno-de-ellos.png": "c7c5",
	"./ninguno-nadie.png": "631c",
	"./no-precisa.png": "ebc7",
	"./no-sabe.png": "0a7c",
	"./no_party.png": "df69",
	"./ns-np.png": "3f14",
	"./otros.png": "6e0d",
	"./partido-aprista.png": "1130",
	"./partido-democratico-somos-peru.png": "f797",
	"./partido-morado.png": "c885",
	"./partido-nacionalista.png": "518b",
	"./partido-politico-contigo.png": "70ed",
	"./partido-politico-nacional-peru-libre.png": "518e",
	"./partido-politico-orden.png": "8119",
	"./partido-popular-cristiano.png": "e41e",
	"./peru-libre.png": "ac84",
	"./peru-nacion.png": "b15e",
	"./peru-patria-segura.png": "9c83",
	"./peru-posible.png": "2244",
	"./peruanos-por-el-kambio.png": "495e",
	"./podemos-peru.png": "5ca4",
	"./progresando-peru.png": "74db",
	"./renacimiento-unido.png": "8a06",
	"./renovacion-popular.png": "58f0",
	"./somos-peru.png": "0277",
	"./todos-por-el-peru.png": "b6d9",
	"./unidad-nacional.png": "4472",
	"./union-por-el-peru.png": "6e44",
	"./victoria-nacional.png": "63e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3302";